export default function (str) {
  const end = str.slice(-4)
  const front = str.slice(0, -4)
  return {
    front,
    end
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/ellipsisDispose.js